import React from "react";
import ReactDOM from "react-dom";
import App from "./Components/App/App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import {UserProvider} from './Contexts/UserContext'

ReactDOM.render(
  <UserProvider>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </UserProvider>
  ,
  document.getElementById("root")
);
